import { render, staticRenderFns } from "./WfDevPublishMsgModal.Style#Drawer.vue?vue&type=template&id=2f0c86af&scoped=true&"
import script from "./WfDevPublishMsgModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./WfDevPublishMsgModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./WfDevPublishMsgModal.Style#Drawer.vue?vue&type=style&index=0&id=2f0c86af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c86af",
  null
  
)

export default component.exports